import { IoMdMailOpen } from "react-icons/io";
import { FaPhoneSquareAlt, } from "react-icons/fa";
import {AiFillInstagram, AiFillLinkedin} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#services', title: 'Services'},
    {id: 4, link: '#portfolio', title: 'Portfolio'},
    {id: 5, link: '#contact', title: 'Contact'}
]

export const socials = [
    {id: 1, target: "_self", link: "mailto:jayeshsolanki19.js@gmail.com", icon: <IoMdMailOpen />},
    {id: 2, target:'_self', link: 'tel:+919624882417', icon: <FaPhoneSquareAlt/>},
    {id: 3, target:'_blank', link: 'https://www.linkedin.com/in/jayesh-solanki-dev/', icon: <AiFillLinkedin/>},
    {id: 4, target:'_blank', link: 'https://www.instagram.com/jayeshsolanki_1307/', icon: <AiFillInstagram/>},
    
]